export default "__VITE_ASSET__5BZohw0j__"